import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react"

import { ChatBubbleNode } from "./Component"

export const ChatBubble = Node.create({
	name: "ChatBubble",
	group: "block",
	content: "block+",
	selectable: false,
	atom: true,
	addAttributes() {
		return {
			created_by: {
				default: -1,
			},
			created_at: {
				isRequired: false,
			},
		}
	},
	parseHTML() {
		return [{ tag: "chat-bubble" }]
	},
	renderHTML({ HTMLAttributes }) {
		return ["chat-bubble", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(ChatBubbleNode)
	},
})
